<template>
  <div class="content-label" @click="openInfoSheet()">
    <p class="content-label__text">Generated with AI</p>

    <InfoIcon class="content-label__icon">
      <ContentLabelText />
    </InfoIcon>

    <BasePopup ref="popup">
      <p class="content-label__sheet">
        <ContentLabelText />
      </p>
    </BasePopup>
  </div>
</template>

<script setup lang="ts">
import { useTemplateRef } from 'vue'
import { platform } from '@/services/platform'

import InfoIcon from '@/app/components/InfoIcon.vue'
import BasePopup from '@/components/ui/BasePopup.vue'
import ContentLabelText from '@/app/components/doc/ContentLabelText.vue'

const popup = useTemplateRef('popup')

function openInfoSheet(): void {
  if (platform.isDesktopWidth()) {
    // We only show the info sheet on mobile. On desktop
    // we use `InfoIcon` to show the disclaimer text on hover.
    return
  }
  popup.value?.show()
}
</script>

<style lang="scss" scoped>
.content-label {
  display: flex;
  align-items: center;
  gap: 6px;
  width: fit-content;
  padding: 5px 10px;
  border-radius: 8px;
  border: 1px solid $c-border-7;
  background: $c-bg;

  &__text {
    color: $c-black-3;
    font-size: 12px;
    line-height: 16px;
    margin-bottom: -2px;
  }

  &__icon {
    width: 16px;
  }

  &__sheet {
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    color: $c-black-15;

    :deep(a) {
      color: $c-blue-4;
      text-decoration: underline;
      @include hover {
        color: $c-blue-2;
      }
    }
  }
}

.night-mode .content-label {
  background: $c-dark-2;
  border-color: $c-dark-3;

  &__text {
    color: $c-dark-7;
  }

  &__sheet {
    color: $c-dark-4;
  }
}
</style>
